export default "__VITE_ASSET__DxjLaplW__"